export var Duration;
(function (Duration) {
    Duration[Duration["In"] = 100] = "In";
    Duration[Duration["Out"] = 150] = "Out";
})(Duration || (Duration = {}));
export const Timing = {
    In: `${Duration.In}ms ease-in`,
    Out: `${Duration.Out}ms ease-out`,
};
//# sourceMappingURL=Transition.js.map